import { defineMessages } from "react-intl";

export const messages = defineMessages({
  searchbarPlaceholder: {
    id: "clientsview.searchbar.placeholder",
    defaultMessage: "Search contact by name",
    description: "placeholder for searchbar",
  },
});
